import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import score from 'src/helper/score'
import cdn from 'src/helper/cdn'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang:langM.en,
    language:"en",
  }

  async componentWillMount() {
    let {language} = this.props.location.query
    language =await getlang(language)
    console.log("language", language)
    this.setState({
      lang: setlang(language,langM),
      language:language,
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
  }


  render() {
    let {language, lang} = this.state
    return (
        <div className='invitation-page'>
                <div className='box'>
                    <div className='gift'>
                        <img className='wire' src='/img/app/invitation/wire.png'/>
                        <img className='streamer' src='/img/app/invitation/streamer.png'/>
                        <img className='avatarurl' src='http://img.chatie.live/app/man.jpg' />
                        <p className='title'>Has sent you an invitation.<br/>Join [Holder] to claim your gifts</p>
                        <div className='gift-box'>
                          <div>
                            <div>
                            <img className='gift-img' src='http://img.chatie.live/app/man.jpg' />
                            </div>
                           
                            <span>3 Days</span>
                          </div>
                          <div>
                          <div>
                            <img className='gift-img' src='http://img.chatie.live/app/man.jpg' />
                            </div>
                            <span>100 Coins</span>
                          </div>
                        </div>
                        <h5>Be a part of App's family</h5>
                    </div>
                    <div className='letter'>
                      <button>Connect with your friend</button>
                      <p>Room ID: 12313</p>
                      <img className='left-img' src='/img/app/invitation/letter_left_img.png'/>
                      <img className='right-img' src='/img/app/invitation/letter_right_img.png'/>
                    </div>
                    <div className='bottom'>
                      <img className='img-box' src='http://img.chatie.live/app/man.jpg'/>
                      <p>Nothing gets better<br/>than chilling With us.</p>
                      <button>Download Now</button>
                      <img className='left-img' src='/img/app/invitation/wire.png'/>
                      <img className='right-img' src='/img/app/invitation/wire.png'/>
                    </div>
                </div>
        </div>
    )
  }

}


// WEBPACK FOOTER //
// src/pages/app/invitation/index.js